import * as React from 'react';
import { SvgIconProps } from '@mui/material';
import { BaseIcon } from '../BaseIcon';
const CameraIcon: React.FC<SvgIconProps> = (props) => (
  <BaseIcon {...props}>
    <path d="M11 10.667c-.186 0-.365.027-.534.079a.917.917 0 0 1-.373 1.754h-.01a.917.917 0 0 1-.835-.54A1.833 1.833 0 1 0 11 10.667Z" />
    <path
      fillRule="evenodd"
      d="M6.84 4.25h8.264l.931 2.385h3.2c.488 0 .957.192 1.304.535.348.344.545.812.545 1.303v9.523c0 .49-.197.959-.545 1.303a1.853 1.853 0 0 1-1.303.534H2.765c-.487 0-.956-.19-1.303-.534a1.832 1.832 0 0 1-.545-1.303V8.473c0-.49.197-.96.545-1.303a1.853 1.853 0 0 1 1.303-.535h3.144l.932-2.385Zm.494 8.25a3.667 3.667 0 1 1 7.333 0 3.667 3.667 0 0 1-7.333 0Z"
      clipRule="evenodd"
    />
  </BaseIcon>
);
export default CameraIcon;
